import {useEffect, useMemo, useState} from 'react'
import {Column} from 'react-table'
import {Tab, TabList, TabPanel, Tabs} from 'react-tabs'
import {KTCard, KTSVG} from '../../../../../../../../_metronic/helpers'
import {
  KTable,
  KTableHeader,
  KTableLoading,
  KTableSelectionCell,
  KTableSelectionCellNonMultiple,
} from '../../../../../../components/UI'
import {KTableProvider, useKTable} from '../../../../../../contexts/KTableProvider'
import {useKhipu} from '../../../../../../hooks/useKhipu'
import {useLimpieza} from '../../../../../../hooks/useLimpieza'
import {TabLimpiezaModel} from '../../../../../../models'
import {ShowSnackBar} from '../../../../../../util/functions'
import {useCampaments} from '../../../../hooks/central/useCampaments'
import {useClients} from '../../../../hooks/central/useClients'
import {useCompanies} from '../../../../hooks/central/useCompanies'
import {useParameters} from '../../../../hooks/central/useParameters'
import {useSites} from '../../../../hooks/central/useSites'
import {CleaningActivitiesColumnModel} from '../../../../model/creationCleaningActivities.model'
import {CREATION_CLEANING_ACTIVITIES_SERVICES} from '../../../../services/creation-cleaning-activities.service'
import {MasiveCleaningActivities} from '../form/masive-cleaning-activities'
import {ModalViewQR} from '../modal/ModalViewQr'
import clsx from 'clsx'

const TableCreationCleaningActivities = () => {
  const {
    data,
    setData,
    setPagination,
    loading,
    setLoading,
    pagination,
    clearSelected,
    selectedOn,
    clearTable,
    updateTable,
    setClearTable,
    setUpdateTable,
    selected,
  } = useKTable()

  const {changeCurrentTabItem, currentTabItem, isAllowed} = useLimpieza()
  const {searchValues, clearSearchValues} = useKhipu()
  const {getCompanies, companies} = useCompanies()
  const {getClients, clients} = useClients()
  const {getSites, sites} = useSites()
  const {getCampaments, campaments} = useCampaments()
  const {cleaningActivities, getCleaningActivities, typeActions, getTypeActions} = useParameters()
  const [showModalViewQR, setShowModalViewQR] = useState<boolean>(false)
  const [cleaningActivitySelected, setCleaningActivitySelected] =
    useState<CleaningActivitiesColumnModel>()

  const [editingCell, setEditingCell] = useState<{
    rowId: string
  } | null>(null)

  const getCleaningActivitiesList = async () => {
    try {
      setLoading(true)
      const {data: response} =
        await CREATION_CLEANING_ACTIVITIES_SERVICES.getCleaningActivitiesList({
          pageNumber: pagination.currentPage,
          size: pagination.perPage,
          ...searchValues,
        })
      if (!response.error) {
        setData(response.data)
        setPagination({
          ...pagination,
          totalResults: response.total,
        })
      }
      setLoading(false)
    } catch (error) {
      setLoading(false)
    }
  }

  useEffect(() => {
    if (currentTabItem.loadingTable || updateTable) {
      clearSelected()
      getCleaningActivitiesList()
      setUpdateTable(false)
      setClearTable(false)
      changeCurrentTabItem({...currentTabItem, loadingTable: false})
    } else {
      getCleaningActivitiesList()
    }
  }, [pagination.currentPage, currentTabItem.loadingTable, updateTable])

  useEffect(() => {
    getCompanies({isCombo: true}, 1)
    getClients({isCombo: true}, 1)
    getSites({isCombo: true}, 1)
    getCampaments({isCombo: true}, 1)
    getCleaningActivities({pageNumber: 1, size: 200, tableName: 'ACTIVIDADLIMPIEZA'})
    getTypeActions({pageNumber: 1, size: 200, tableName: 'TIPOACCION'})

    return () => {
      clearSearchValues()
    }
  }, [])

  const handleViewQR = (row: CleaningActivitiesColumnModel) => {
    setCleaningActivitySelected(row)
    setShowModalViewQR(true)
  }

  const handleViewPanel = (rowData: CleaningActivitiesColumnModel) => {
    const obj: TabLimpiezaModel = {
      ...currentTabItem,
      showPanel: true,
      idToEdit: rowData.Id,
      detailRow: rowData,
      content: {
        ...currentTabItem.content,
        detailPanel: 'tab-creation-cleaning-activities',
      },
      idToDelete: '',
      currentExternalTab: 0,
    }
    clearSelected()
    changeCurrentTabItem(obj)
  }

  const handleGetId = (id: any) => {
    const idAsString = id ? String(id) : ''
    const idChange = idAsString === currentTabItem.idToDelete ? '' : idAsString
    const obj: TabLimpiezaModel = {
      ...currentTabItem,
      showPanel: false,
      idToDelete: idChange,
      idToEdit: '',
    }
    changeCurrentTabItem(obj)
  }

  useEffect(() => {
    changeCurrentTabItem({...currentTabItem, selected})
  }, [selected])

  const columns: Column<any>[] = useMemo(
    () => [
      {
        Header: (props) => <KTableHeader tableProps={props} />,
        id: 'selection',
        Cell: ({...props}) => (
          <KTableSelectionCell id={props.data[props.row.index].Id} clickHandler={handleGetId} />
        ),
      },
      {
        Header: (props) => (
          <KTableHeader tableProps={props} title='Nro de Orden' name={'NroOrden'} searcheable />
        ),
        accessor: 'NroOrden',
        Cell: ({value, row, column}) => {
          const isEditing = editingCell?.rowId === row.id
          const [localValue, setLocalValue] = useState(value ?? '')
          useEffect(() => {
            if (isEditing) {
              setLocalValue(value ?? '')
            }
          }, [isEditing, value])
          if (isEditing) {
            return (
              <input
                autoFocus
                className='form-control sdx-centra-input-form'
                value={localValue}
                onChange={(e) => setLocalValue(e.target.value)}
                onFocus={(e) => {
                  e.target.select()
                }}
                onBlur={async () => {
                  setEditingCell(null)
                  if (localValue !== value) {
                    setData((prevData) =>
                      prevData.map((item, index) =>
                        index === row.index ? {...item, NroOrden: localValue} : item,
                      ),
                    )
                    CREATION_CLEANING_ACTIVITIES_SERVICES.updateOrderNumber({
                      id: row.original.Id,
                      nroOrden: localValue,
                    })
                      .then((response) => {
                        if (response.data.error) {
                          setData((prevData) =>
                            prevData.map((item, index) =>
                              index === row.index ? {...item, NroOrden: value} : item,
                            ),
                          )
                          ShowSnackBar(response.data.message, 'error')
                        } else {
                          ShowSnackBar('Número de orden actualizado correctamente', 'success')
                        }
                      })
                      .catch(() => {
                        setData((prevData) =>
                          prevData.map((item, index) =>
                            index === row.index ? {...item, NroOrden: value} : item,
                          ),
                        )
                        ShowSnackBar('Error al actualizar el número de orden', 'error')
                      })
                  }
                }}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    e.currentTarget.blur()
                  }
                  if (e.key === 'Escape') {
                    setEditingCell(null)
                  }
                }}
              />
            )
          }
          return (
            <div
              onDoubleClick={() => {
                if (row.original.TipoAccion !== 'INGRESO SALIDA') {
                  setEditingCell({rowId: row.id})
                }
              }}
              className={clsx({'cursor-pointer': row.original.TipoAccion !== 'INGRESO SALIDA'})}
            >
              {row.original.TipoAccion === 'INGRESO SALIDA' ? '-' : value}
            </div>
          )
        },
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Actividad de Limpieza'
            name={'Actividad'}
            searcheable
            // data={cleaningActivities}
          />
        ),
        accessor: 'Actividad',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Tiempo Promedio'
            name={'MinutosPromedio'}
            searcheable
            number
          />
        ),
        accessor: 'MinutosPromedio',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Tipo de Acción'
            name={'TipoAccionId'}
            selecteable
            data={typeActions}
          />
        ),
        accessor: 'TipoAccion',
      },
      {
        Header: (props) => (
          <KTableHeader tableProps={props} title='Módulo' name={'CodigoModulo'} searcheable />
        ),
        accessor: 'Modulo',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Habitación'
            name={'CodigoHabitacion'}
            searcheable
          />
        ),
        accessor: 'Habitacion',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Cliente'
            name={'ClienteId'}
            selecteable
            data={clients}
          />
        ),
        accessor: 'Cliente',
      },
      {
        Header: (props) => (
          <KTableHeader tableProps={props} title='Site' name={'SiteId'} selecteable data={sites} />
        ),
        accessor: 'Site',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Campamento'
            name={'CampamentoId'}
            selecteable
            data={campaments}
          />
        ),
        accessor: 'Campamento',
      },
      {
        Header: (props) => <KTableHeader tableProps={props} title='Ver QR' />,
        id: 'actions',
        Cell: ({...props}) => (
          <div
            className='d-flex justify-content-center flex-shrink-0'
            onClick={() => handleViewQR(props.row.original)}
          >
            <a href='#' className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'>
              <KTSVG path='/media/icons/duotune/general/gen005.svg' className='svg-icon-3' />
            </a>
          </div>
        ),
      },
      {
        Header: (props) => <KTableHeader tableProps={props} title='Ver' />,
        id: 'actions2',
        Cell: ({...props}) => (
          <div
            className='d-flex justify-content-center flex-shrink-0'
            onClick={() => handleViewPanel(props.row.original)}
          >
            <a href='#' className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'>
              <KTSVG path='/media/icons/duotune/general/gen055.svg' className='svg-icon-3' />
            </a>
          </div>
        ),
      },
    ],
    [selectedOn, campaments, clients, sites, typeActions, editingCell],
  )

  return (
    <KTCard shadow className='m-5'>
      <KTable data={data} columns={columns} />
      {loading ? <KTableLoading title='Cargando...' /> : null}
      {showModalViewQR && cleaningActivitySelected && (
        <ModalViewQR
          show={showModalViewQR}
          setShow={setShowModalViewQR}
          cleaningActivity={cleaningActivitySelected}
        />
      )}
    </KTCard>
  )
}

export const CreationCleaningActivitiesTable = () => {
  return (
    <KTableProvider>
      <div className='sdx_content_tab_panel'>
        <Tabs className={'sdx_sub_react_tab_panel '}>
          <TabList className={'sdx_sub_tab_panel p-0'}>
            <Tab className={'sdx_sub_tab_panel_option'}>Actividades de Limpieza</Tab>
            <Tab className={'sdx_sub_tab_panel_option'}>Descarga Masiva</Tab>
          </TabList>
          <TabPanel>
            <TableCreationCleaningActivities />
          </TabPanel>
          <TabPanel>
            <MasiveCleaningActivities />
          </TabPanel>
        </Tabs>
      </div>
    </KTableProvider>
  )
}
